import React, { memo, ReactNode, useMemo, useRef } from 'react'

import './index.scss'
import Icon from '../Icon'
import { useBounds } from '../../hooks/useBounds'

type Option = {
  label: string | ReactNode
  icon?: string
  onClick: () => void
  onKeyDown?: (e: Event) => void
}

type DropdownSelection = {
  options: Option[]
  boundsRef?: any
  align?: 'left' | 'right'
  width?: number
}

const DropDownSelection = memo(({ options, boundsRef, width, align = 'right' }: DropdownSelection) => {
  const dropdownRef = useRef()

  const { bounds: buttonBounds } = useBounds(boundsRef)

  const styles = useMemo(() => {
    const styleObj: React.CSSProperties = {}
    if (buttonBounds) {
      if (typeof buttonBounds?.width === 'string') styleObj.width = buttonBounds.width
      else styleObj.width = `${buttonBounds?.width}px`

      if (buttonBounds.top) styleObj.top = buttonBounds.top + buttonBounds.height + 1

      if (align === 'right') styleObj.right = window.innerWidth - buttonBounds.right
      else styleObj.left = buttonBounds.left
    }

    if (width) {
      styleObj.width = `${width}px`
      styleObj.minWidth = `${width}px`
    } else {
      styleObj.width = `${buttonBounds?.width}px`
    }

    return styleObj
  }, [buttonBounds, align, width])

  return (
    <div ref={dropdownRef} className="DropdownSelection" style={styles}>
      {options.map((option) => {
        const { label, icon, onClick, onKeyDown } = option
        return (
          <div
            className="DropdownSelection__option"
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
          >
            {icon && (<Icon icon={icon} />)}
            {label}
          </div>
        )
      })}
    </div>
  )
})

export default DropDownSelection
